import Vue from 'vue';
import Router from 'vue-router';
import routerInfo from './router';
import App from './App.vue';
import { install } from '@/i18n';
import { rem, vueTap, initReport, request } from '@tencent/ppd-base-libs';
import axios from 'axios';

Vue.use(install);
// 处理路由信息
Vue.use(Router);
const router = new Router(routerInfo);

request.init(axios);
initReport({
  router,
  // @ts-ignore
  appEnv: process.env.VUE_APP_ENV,
  // @ts-ignore
  business: process.env.VUE_APP_PKGNAME,  // 区分业务，用于elk
  isReportPageStayedTime: true, // 是否上报页面停留时间
  sentry: {
    dsn: '',
    // webpack变异全局变量
    release: process.env.VUE_APP_SENTRY_VERSION,
  },
  bi: {
    reportNeedLogin: true,
  },
}, Vue);

// 开启rem布局
rem();
// 开启vtap
Vue.use(vueTap);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
